import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({ selector: '[docTab]' })
export class DocTabPanelDirective {
  @Input('docTab') label = '';

  constructor(public tpl: TemplateRef<unknown>) {}
}
